import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useField } from '@unform/core';
import { mascararCodigoInstituicaoDeEnsino } from '../../functions/mask';
import { mascararCpf } from '../../functions/validateCPF';
import { Icone } from '../Icone';
import {
  ConteinerInput,
  ConteinerIcon,
  BordaInput,
  InputArea,
  CampoInput,
  TextoDeErro,
} from './styles';

export function Input({
  nome,
  placeholder,
  titulo,
  aoAtribuirValor,
  mascara = false,
  tipoDeMascara = 'cpf',
  desabilitado = false,
  aoPressionarEnter = null,
  tipo = 'text',
  valorMaximo = null,
  comprimentoMaximo = null,
  value,
  proibirColar,
}) {
  const [senhaVisivel, atribuirSenhaVisivel] = useState(false);
  const [limparCampo, atribirLimparCampo] = useState(false);

  const inputRef = useRef(null);

  const { fieldName, registerField, defaultValue, error } = useField(nome);

  const aoMudar = (event) => {
    if (mascara) {
      event.target.value = mascarar(event.target.value);
    }
    if (aoAtribuirValor) aoAtribuirValor(event.target.value);

    inputRef.current.value = event.target.value;
  };

  const aoPressionarTecla = (evento) => {
    if (evento.key === 'Enter') {
      evento.preventDefault();
      if (aoPressionarEnter) {
        aoPressionarEnter();
      }
    }
  };

  const mascarar = (value) => {
    switch (tipoDeMascara) {
      case 'cpf':
        return mascararCpf(value);

      case 'codIE':
        return mascararCodigoInstituicaoDeEnsino(value);
      default:
        return mascararCpf(value);
    }
  };

  const proibirColaNoCampo = () => {
    atribirLimparCampo(true);

    toast.error('Este campo não pode receber valores copiados.');
  };

  useEffect(() => {
    if (defaultValue) {
      if (aoAtribuirValor) aoAtribuirValor(mascara ? mascarar(defaultValue) : defaultValue);
      else if (mascara) {
        inputRef.current.value = mascarar(defaultValue);
      }
    }
  }, [defaultValue]);

  useEffect(() => {
    if (limparCampo) {
      setTimeout(() => {
        atribirLimparCampo(false);
      }, 500);
    }
  }, [limparCampo]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <>
      <InputArea>
        {titulo ? <label>{titulo}</label> : null}
        <ConteinerInput>
          <CampoInput
            ref={inputRef}
            placeholder={placeholder}
            defaultValue={defaultValue}
            onChange={aoMudar}
            disabled={desabilitado}
            onKeyPress={aoPressionarTecla}
            type={tipo === 'password' ? (senhaVisivel ? 'text' : 'password') : tipo}
            max={valorMaximo}
            value={limparCampo ? '' : value}
            maxLength={comprimentoMaximo}
            onPaste={proibirColar && proibirColaNoCampo}
            autocomplete='off'
          />
          {tipo === 'password' && (
            <ConteinerIcon
              onClick={() => {
                atribuirSenhaVisivel(!senhaVisivel);
              }}
            >
              {senhaVisivel ? <Icone nome='FaRegEye' /> : <Icone nome='FaRegEyeSlash' />}
            </ConteinerIcon>
          )}
          <BordaInput error={error} />
        </ConteinerInput>
        {error && <TextoDeErro>{error}</TextoDeErro>}
      </InputArea>
    </>
  );
}
